var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "date-period" }, [
    _c(
      "button",
      {
        staticClass: "date-period__nav",
        attrs: { type: "button", "aria-label": _vm.$t("components.fields.to") },
        on: { click: _vm.backPeriod },
      },
      [
        _c("i", {
          staticClass: "fas fa-chevron-left",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    ),
    _c(
      "div",
      { staticClass: "date-period__label" },
      [
        _vm.isWeek
          ? [
              _c("formatted-date-component", {
                attrs: { val: _vm.start, "without-year": true },
              }),
              _c("span", { staticClass: "date-period__to" }, [
                _vm._v(_vm._s(_vm.$t("components.fields.to"))),
              ]),
              _c("formatted-date-component", {
                attrs: { val: _vm.end, "without-year": true },
              }),
            ]
          : _vm.isMonth
          ? [
              _c("span", { staticClass: "month" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "components.date.month_long[" + _vm.start.getMonth() + "]"
                    ) +
                      " " +
                      _vm.start.getFullYear()
                  )
                ),
              ]),
            ]
          : [_c("span", [_vm._v(_vm._s(_vm.$formatDate(this.start)))])],
      ],
      2
    ),
    _c(
      "button",
      {
        staticClass: "date-period__nav",
        attrs: { type: "button", "aria-label": "next" },
        on: { click: _vm.nextPeriod },
      },
      [
        _c("i", {
          staticClass: "fas fa-chevron-right",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }